import type { ReduxState } from '@spa/redux/ReduxState'

export const getGridSelection = (state: ReduxState) => {
  return state.plannings.gridSelection
}
